import { render, staticRenderFns } from "./Customized.vue?vue&type=template&id=398cbe24"
import script from "./Customized.vue?vue&type=script&lang=js"
export * from "./Customized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports